import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Response } from "@angular/http";
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/operators';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
@Injectable()
export class UserService {
  readonly rootUrl = 'https://bg.aqarqo.com/';
  url: string = 'https://bg.aqarqo.com/';

  // readonly rootUrl = 'https://api.AqARCOarabic.com/';
  // url: string = 'https://api.AqARCOarabic.com/';  
  constructor(private Http: Http) { }
  login(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { email: item.email, password: item.password };
    console.log(item)
    return this.Http.post(this.url + 'api/auth', JSON.stringify(credentials), { headers: headers });
  }

  checktoken(token, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, id };
    console.log(token, id)
    return this.Http.post(this.url + 'api/checktoken', JSON.stringify(credentials), { headers: headers });
  }
  selectcountries() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {};
    return this.Http.post(this.url + 'api/selectcountries', JSON.stringify(credentials), { headers: headers });
  }
  addcountries(token, yachts, priority, flag, arabic, english, french, turkish, buy, sell, asked, isactive, showregions, namearabic, nameenglish, namefrench, nameturkish) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, yachts, priority, flag, arabic, english, french, turkish, buy, sell, asked, isactive, showregions, namearabic, nameenglish, namefrench, nameturkish };
    console.log(credentials)
    return this.Http.post(this.url + 'api/addcountries', JSON.stringify(credentials), { headers: headers });
  }

  changeCountries(token, yachts, priority, flag, arabic, english, french, turkish, buy, sell, asked, isactive, showregions, namearabic, nameenglish, namefrench, nameturkish, defaultregion, id, companies) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, yachts, priority, flag, arabic, english, french, turkish, buy, sell, asked, isactive, showregions, namearabic, nameenglish, namefrench, nameturkish, defaultregion, id, companies };
    console.log(credentials)
    return this.Http.post(this.url + 'api/changecountries', JSON.stringify(credentials), { headers: headers });
  }

  selectregions() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {};
    return this.Http.post(this.url + 'api/selectregions', JSON.stringify(credentials), { headers: headers });
  }
  addregions(token, priority, buy, sell, asked, country, arabicname, englishname, frenchname, turkishname, img, isactive, createdby, modifiedby) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {
      token, priority, buy, sell, asked, country, arabicname, englishname, frenchname, turkishname, img, isactive, createdby, modifiedby
    };
    console.log(credentials)
    return this.Http.post(this.url + 'api/addregions', JSON.stringify(credentials), { headers: headers });
  }

  changeregions(token, priority, buy, sell, asked, country, arabicname, englishname, frenchname, turkishname, img, isactive, createdby, modifiedby, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, priority, buy, sell, asked, country, arabicname, englishname, frenchname, turkishname, img, isactive, createdby, modifiedby, id };
    console.log(credentials)
    return this.Http.post(this.url + 'api/changeregions', JSON.stringify(credentials), { headers: headers });
  }
  selectcategories() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {};
    return this.Http.post(this.url + 'api/selectcategories', JSON.stringify(credentials), { headers: headers });
  }
  addcategories(token, priority, region, country, arabicname, englishname, frenchname, turkishname, img, isactive, createdby, modifiedby) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {
      token, priority, region, country, arabicname, englishname, frenchname, turkishname, img, isactive, createdby, modifiedby
    };
    console.log(credentials)
    return this.Http.post(this.url + 'api/addcategories', JSON.stringify(credentials), { headers: headers });
  }

  
  changecategories(token, priority, region, country, arabicname, englishname, frenchname, turkishname, img, isactive, createdby, modifiedby, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, priority, region, country, arabicname, englishname, frenchname, turkishname, img, isactive, createdby, modifiedby, id };
    console.log(credentials)
    return this.Http.post(this.url + 'api/changecategories', JSON.stringify(credentials), { headers: headers });
  }
  selectcategoriesregion() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {};
    return this.Http.post(this.url + 'api/selectcategoriesregion', JSON.stringify(credentials), { headers: headers });
  }
  addcategoriesregion(token, categories, region, createdby, modifiedby, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {
      token, categories, region, createdby, modifiedby, id
    };
    console.log(credentials)
    return this.Http.post(this.url + 'api/addcategoriesregion', JSON.stringify(credentials), { headers: headers });
  }

  changecategoriesregion(token, categories, region, createdby, modifiedby, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, categories, region, createdby, modifiedby, id };
    console.log(credentials)
    return this.Http.post(this.url + 'api/changecategoriesregion', JSON.stringify(credentials), { headers: headers });
  }

  deletecategorieregion(token, categories, region, createdby, modifiedby, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, categories, region, createdby, modifiedby, id };
    console.log(credentials)
    return this.Http.post(this.url + 'api/deletecategoriesregion', JSON.stringify(credentials), { headers: headers });
  }

  selectslider() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {};
    return this.Http.post(this.url + 'api/selectslider', JSON.stringify(credentials), { headers: headers });
  }
  addslider(token, country, img, is_active, startpublish, endpublish, createdby, action, value) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, country, img, is_active, startpublish, endpublish, createdby, action, value };
    console.log(credentials)
    return this.Http.post(this.url + 'api/addslider', JSON.stringify(credentials), { headers: headers });
  }

  changeslider(token, country, img, is_active, startpublish, endpublish, createdby, action, value, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, country, img, is_active, startpublish, endpublish, createdby, action, value, id };
    console.log(credentials)
    return this.Http.post(this.url + 'api/changeslider', JSON.stringify(credentials), { headers: headers });
  }
  deleteslider(token, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, id };
    console.log(credentials)
    return this.Http.post(this.url + 'api/deleteslider', JSON.stringify(credentials), { headers: headers });
  }


  selectcompany() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {};
    return this.Http.post(this.url + 'api/selectcompany', JSON.stringify(credentials), { headers: headers });
  }
  addcompany(token, country, img, is_active, startpublish, endpublish, createdby, action, value) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, country, img, is_active, startpublish, endpublish, createdby, action, value };
    console.log(credentials)
    return this.Http.post(this.url + 'api/addcompany', JSON.stringify(credentials), { headers: headers });
  }

  changecompany(token, country, img, is_active, startpublish, endpublish, createdby, action, value, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, country, img, is_active, startpublish, endpublish, createdby, action, value, id };
    console.log(credentials)
    return this.Http.post(this.url + 'api/changecompany', JSON.stringify(credentials), { headers: headers });
  }
  deletecompany(token, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, id };
    console.log(credentials)
    return this.Http.post(this.url + 'api/deletecompany', JSON.stringify(credentials), { headers: headers });
  }


  
  selectarticles() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {};
    return this.Http.post(this.url + 'api/selectarticles', JSON.stringify(credentials), { headers: headers });
  }
  addarticles(token, title1, text1, title2, text2, title3, text3, img1, img2, img3, video, language) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, title1, text1, title2, text2, title3, text3, img1, img2, img3, video, language };
    console.log(credentials)
    return this.Http.post(this.url + 'api/addarticles', JSON.stringify(credentials), { headers: headers });
  }

  changearticles(token, title1, text1, title2, text2, title3, text3, img1, img2, img3, video,language, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, title1, text1, title2, text2, title3, text3, img1, img2, img3, video, id, language };
    console.log(credentials)
    return this.Http.post(this.url + 'api/changearticles', JSON.stringify(credentials), { headers: headers });
  }
  deletearticles(token, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, id };
    console.log(credentials)
    return this.Http.post(this.url + 'api/deletearticles', JSON.stringify(credentials), { headers: headers });
  } 
  selectareac(country) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { country };
    return this.Http.post(this.url + 'api/selectareac', JSON.stringify(credentials), { headers: headers });
  }
  selectarea() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {};
    return this.Http.post(this.url + 'api/selectarea', JSON.stringify(credentials), { headers: headers });
  }
  addarea(token, priority, region, country, arabicname, englishname, frenchname, turkishname, img, isactive, createdby, modifiedby) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {
      token, priority, region, country, arabicname, englishname, frenchname, turkishname, img, isactive, createdby, modifiedby
    };
    console.log(credentials)
    return this.Http.post(this.url + 'api/addarea', JSON.stringify(credentials), { headers: headers });
  }

  changearea(token, priority, region, country, arabicname, englishname, frenchname, turkishname, img, isactive, createdby, modifiedby, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, priority, region, country, arabicname, englishname, frenchname, turkishname, img, isactive, createdby, modifiedby, id };
    console.log(credentials)
    return this.Http.post(this.url + 'api/changearea', JSON.stringify(credentials), { headers: headers });
  }


  selectcategoriesarea() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {};
    return this.Http.post(this.url + 'api/selectcategoriesarea', JSON.stringify(credentials), { headers: headers });
  }
  addcategoriesarea(token, area, categories, createdby, modifiedby, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {
      token, area, categories, createdby, modifiedby, id
    };
    console.log(credentials)
    return this.Http.post(this.url + 'api/addcategoriesarea', JSON.stringify(credentials), { headers: headers });
  }

  addmcategoriesarea(token, list, createdby, modifiedby, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {
      token, list: JSON.stringify(list), createdby, modifiedby, id
    };
    console.log(credentials)
    return this.Http.post(this.url + 'api/addmcategoriesarea', JSON.stringify(credentials), { headers: headers });
  }

  addmcategoriesregion(token, list, createdby, modifiedby, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {
      token, list: JSON.stringify(list), createdby, modifiedby, id
    };
    console.log(credentials)
    return this.Http.post(this.url + 'api/addmcategoriesregion', JSON.stringify(credentials), { headers: headers });
  }

  changecategoriesarea(token, area, categories, createdby, modifiedby, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, area, categories, createdby, modifiedby, id };
    console.log(credentials)
    return this.Http.post(this.url + 'api/changecategoriesarea', JSON.stringify(credentials), { headers: headers });
  }

  deletecategoriesarea(token, area, categories, createdby, modifiedby, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, area, categories, createdby, modifiedby, id };
    console.log(credentials)
    return this.Http.post(this.url + 'api/deletecategoriesarea', JSON.stringify(credentials), { headers: headers });
  }
  
  employees() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {};
    return this.Http.post(this.url + 'api/employees', JSON.stringify(credentials), { headers: headers });
  }
  selectsubcategoriesarea() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {};
    return this.Http.post(this.url + 'api/selectsubcategoriesarea', JSON.stringify(credentials), { headers: headers });
  }
  addsubcategoriesarea(token, area, subcategories, createdby, modifiedby, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {
      token, area, subcategories, createdby, modifiedby, id
    };
    console.log(credentials)
    return this.Http.post(this.url + 'api/addsubcategoriesarea', JSON.stringify(credentials), { headers: headers });
  }

  changesubcategoriesarea(token, area, subcategories, createdby, modifiedby, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, area, subcategories, createdby, modifiedby, id };
    console.log(credentials)
    return this.Http.post(this.url + 'api/changesubcategoriesarea', JSON.stringify(credentials), { headers: headers });
  }

  deletecategoriecategories(token, area, subcategories, createdby, modifiedby, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, area, subcategories, createdby, modifiedby, id };
    console.log(credentials)
    return this.Http.post(this.url + 'api/deletesubcategoriesarea', JSON.stringify(credentials), { headers: headers });
  }

  selectsubarea() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {};
    return this.Http.post(this.url + 'api/selectsubarea', JSON.stringify(credentials), { headers: headers });
  }
  addsubarea(token, category, country, arabicname, englishname, frenchname, turkishname, img, isactive, createdby, modifiedby) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {
      token, category, country, arabicname, englishname, frenchname, turkishname, img, isactive, createdby, modifiedby, area: 0
    };
    console.log(credentials)
    return this.Http.post(this.url + 'api/addsubarea', JSON.stringify(credentials), { headers: headers });
  }

  changesubarea(token, category, country, arabicname, englishname, frenchname, turkishname, img, isactive, createdby, modifiedby, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, category, country, arabicname, englishname, frenchname, turkishname, img, isactive, createdby, modifiedby, id, area: 0 };
    console.log(credentials)
    return this.Http.post(this.url + 'api/changesubarea', JSON.stringify(credentials), { headers: headers });
  }









  fetchQuestions(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token: item };
    console.log(item)
    return this.Http.post(this.url + 'api/fulllistquestion', JSON.stringify(credentials), { headers: headers });
  }
  fetchUsers(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token: item };
    console.log(item)
    return this.Http.post(this.url + 'api/listuser', JSON.stringify(credentials), { headers: headers });
  }

  Updateq(token, id, answer_note,
    question_title,
    question_pre_title,
    question_title_extra,
    active,
    active_multiple_chapter,
    premium) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {
      token, id, answer_note,
      question_title,
      question_pre_title,
      question_title_extra,
      active,
      active_multiple_chapter,
      premium
    };
    console.log(token, id, active)
    return this.Http.post(this.url + 'api/updateq', JSON.stringify(credentials), { headers: headers });
  }
  deleteq(token, id, answer_note,
    question_title,
    question_pre_title,
    question_title_extra,
    active,
    active_multiple_chapter,
    premium) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {
      token, id, answer_note,
      question_title,
      question_pre_title,
      question_title_extra,
      active,
      active_multiple_chapter,
      premium
    };
    console.log(token, id, active)
    return this.Http.post(this.url + 'api/deleteq', JSON.stringify(credentials), { headers: headers });
  }

  Block(token, id, active) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, id, active };
    console.log(token, id, active)
    return this.Http.post(this.url + 'api/blockuser', JSON.stringify(credentials), { headers: headers });
  }
  uploadfile(token, file, type) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {
      token, file, type

    };
    return this.Http.post(this.url + 'api/s3push', JSON.stringify(credentials), { headers: headers });
  }
  compressfile(token, file, type) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {
      token, file, type
    };
    return this.Http.post(this.url + 'photos', JSON.stringify(credentials), { headers: headers });
  }
  cfile(token, file, type) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {
      token, file, type
    };
    return this.Http.post(this.url + 'pho', JSON.stringify(credentials), { headers: headers });
  }
  addq(token, wrong_answer, correct_answer, answer_note, question, question_title, question_title_extra, question_voice, question_img, answer_voice, question_pre_title, active, premium, active_multiple_chapter, chapter, type, answer_img) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, wrong_answer, correct_answer, answer_note, question, question_title, question_title_extra, question_voice, question_img, answer_voice, question_pre_title, active, premium, active_multiple_chapter, chapter, type, answer_img };

    return this.Http.post(this.url + 'api/addquestion', JSON.stringify(credentials), { headers: headers });
  }
  selectusers() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {};
    return this.Http.post(this.url + 'api/selectusers', JSON.stringify(credentials), { headers: headers });
  }
  selectusersadmin() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {};
    return this.Http.post(this.url + 'api/selectusersadmin', JSON.stringify(credentials), { headers: headers });
  }
  selectusershr() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {};
    return this.Http.post(this.url + 'api/selectusershr', JSON.stringify(credentials), { headers: headers });
  }
  selectusersdataentry() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {};
    return this.Http.post(this.url + 'api/selectusersdataentry', JSON.stringify(credentials), { headers: headers });
  }
  selectuserssupdataentry() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {};
    return this.Http.post(this.url + 'api/selectuserssupdataentry', JSON.stringify(credentials), { headers: headers });
  }

  selectphotosByaqar(aqar) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { aqar: aqar };
    return this.Http.post(this.url + 'api/selectphotosByaqar', JSON.stringify(credentials), { headers: headers });
  }
  selectuserssales() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {};
    return this.Http.post(this.url + 'api/selectuserssales', JSON.stringify(credentials), { headers: headers });
  }
  addusers(token, country,name, email, password, created, blocked, type) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {
      country,  token, name, email, password, created, blocked, type
    };
    console.log(credentials)
    return this.Http.post(this.url + 'api/addusers', JSON.stringify(credentials), { headers: headers });
  }

  changeusers(token, country,name, email, password, created, blocked, type, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {
      country,  token, name, email, password, created, blocked, type, id
    };
    console.log(credentials)
    return this.Http.post(this.url + 'api/changeusers', JSON.stringify(credentials), { headers: headers });
  }
  resetpass(token, password, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {
      token, password, id
    };
    console.log(credentials)
    return this.Http.post(this.url + 'api/resetpass', JSON.stringify(credentials), { headers: headers });
  }

  addphotos(token, img, createdby, createdat, aqar) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, img, createdby, createdat, aqar };
    console.log(credentials)
    return this.Http.post(this.url + 'api/addphotos', JSON.stringify(credentials), { headers: headers });
  }
  deleteusers(token, name, email, password, created, blocked, type, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, name, email, password, created, blocked, type, id };
    console.log(credentials)
    return this.Http.post(this.url + 'api/deleteusers', JSON.stringify(credentials), { headers: headers });
  }
  deletephotos(token, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, id };
    console.log(credentials)
    return this.Http.post(this.url + 'api/deletephotos', JSON.stringify(credentials), { headers: headers });
  }
  selectaqar(token, type ,id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, type, id };
    return this.Http.post(this.url + 'api/selecteqar', JSON.stringify(credentials), { headers: headers });
  }

  addaqar(token, video, country, type, area, catrgory, subarea, mainphoto, blotArea, buildArea, building, city, company, createdAt, createdBy, currency, descrAr, descrEn, descrFr, descrTr, email, entryBy, expiration, footPrice, furniture, hasView, isApartment, isBedSpace, isBuilding, isIndividual, isPenthouse, isPremium, isRejected, isSharing, isStudio, isTower, isTownhouse, isVilla, lat, lng, maidRoom, nameEn, nameAr, nameFr, nameTr, nbrAppartment, nbrBathroom, nbrBedRooms, nbrBuilding, nbrDinning, nbrKitchen, nbrLivingroom, nbrRooms, nbrVilla, notes, phone, whatsapp, premium, premiumUntil, price, publishedAt, publishedBy, rate, ref, residence, startingAt, status, statusReason, street, tenant, titleAr, titleEn, titleFr, titleTr, typeKitchen, typePartial, unit, updatedAt, updatedBy, villaType) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {
      token, video, country, type, area, catrgory, subarea, mainphoto, blotArea, buildArea, building, city, company, createdAt, createdBy, currency, descrAr, descrEn, descrFr, descrTr, email, entryBy, expiration, footPrice, furniture, hasView, isApartment, isBedSpace, isBuilding, isIndividual, isPenthouse, isPremium, isRejected, isSharing, isStudio, isTower, isTownhouse, isVilla, lat, lng, maidRoom, nameEn, nameAr, nameFr, nameTr, nbrAppartment, nbrBathroom, nbrBedRooms, nbrBuilding, nbrDinning, nbrKitchen, nbrLivingroom, nbrRooms, nbrVilla, notes, phone, whatsapp, premium, premiumUntil, price, publishedAt, publishedBy, rate, ref, residence, startingAt, status, statusReason, street, tenant, titleAr, titleEn, titleFr, titleTr, typeKitchen, typePartial, unit, updatedAt, updatedBy, villaType
    };
    console.log(credentials)
    return this.Http.post(this.url + 'api/addaqar', JSON.stringify(credentials), { headers: headers });
  }

  changeaqar(token, broker, video, country, type, area, catrgory, subarea, mainphoto, blotArea, buildArea, building, city, company, createdAt, createdBy, currency, descrAr, descrEn, descrFr, descrTr, email, entryBy, expiration, footPrice, furniture, hasView, isApartment, isBedSpace, isBuilding, isIndividual, isPenthouse, isPremium, isRejected, isSharing, isStudio, isTower, isTownhouse, isVilla, lat, lng, maidRoom, nameEn, nameAr, nameFr, nameTr, nbrAppartment, nbrBathroom, nbrBedRooms, nbrBuilding, nbrDinning, nbrKitchen, nbrLivingroom, nbrRooms, nbrVilla, notes, phone, whatsapp, premium, premiumUntil, price, publishedAt, publishedBy, rate, ref, residence, startingAt, status, statusReason, street, tenant, titleAr, titleEn, titleFr, titleTr, typeKitchen, typePartial, unit, updatedAt, updatedBy, villaType, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {
      broker, token, video, country, type, area, catrgory, subarea, mainphoto, blotArea, buildArea, building, city, company, createdAt, createdBy, currency, descrAr, descrEn, descrFr, descrTr, email, entryBy, expiration, footPrice, furniture, hasView, isApartment, isBedSpace, isBuilding, isIndividual, isPenthouse, isPremium, isRejected, isSharing, isStudio, isTower, isTownhouse, isVilla, lat, lng, maidRoom, nameEn, nameAr, nameFr, nameTr, nbrAppartment, nbrBathroom, nbrBedRooms, nbrBuilding, nbrDinning, nbrKitchen, nbrLivingroom, nbrRooms, nbrVilla, notes, phone, whatsapp, premium, premiumUntil, price, publishedAt, publishedBy, rate, ref, residence, startingAt, status, statusReason, street, tenant, titleAr, titleEn, titleFr, titleTr, typeKitchen, typePartial, unit, updatedAt, updatedBy, villaType, id
    };
    console.log(credentials)
    return this.Http.post(this.url + 'api/changeaqar', JSON.stringify(credentials), { headers: headers });
  }


  deleteaqar(token, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, id };
    console.log(credentials)
    return this.Http.post(this.url + 'api/deleteaqar', JSON.stringify(credentials), { headers: headers });
  }






  listclinic() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {};
    return this.Http.post(this.url + 'api/findallclinic', JSON.stringify(credentials), { headers: headers });
  }
  findallappointment() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {};
    return this.Http.post(this.url + 'api/findallappointment', JSON.stringify(credentials), { headers: headers });
  }
  findalluser() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {};
    return this.Http.post(this.url + 'api/findalluser', JSON.stringify(credentials), { headers: headers });
  }

  listcategory() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {};
    return this.Http.post(this.url + 'api/findallcategory', JSON.stringify(credentials), { headers: headers });
  }
  view_fixed_values() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {};
    return this.Http.post(this.url + 'api/view_fixed_values', JSON.stringify(credentials), { headers: headers });
  }
  findalloffers() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {};
    return this.Http.post(this.url + 'api/findalloffersadmin', JSON.stringify(credentials), { headers: headers });
  }
  findallpromotion() {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = {};
    return this.Http.post(this.url + 'api/findallpromotion', JSON.stringify(credentials), { headers: headers });
  }
  saveChangesclinic(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { item };
    return this.Http.post(this.url + 'api/updateclinic', JSON.stringify(credentials), { headers: headers });
  }
  verifyWebToken(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { item };
    return this.Http.post(this.url + 'api/verifyWebToken', JSON.stringify(credentials), { headers: headers });
  }
  // addphoto(id, image) {
  //  let headers = new Headers();
  // headers.append('Content-Type', 'application/json');
  // let credentials = {  token :  AppComponent.token  , 
  //  id, image
  // };
  // return this.Http.post(this.url + 'api/addphoto', JSON.stringify(credentials), {headers: headers});
  // } 
  // changecover(id, image) {
  //  let headers = new Headers();
  // headers.append('Content-Type', 'application/json');
  // let credentials = {  token :  AppComponent.token  , 
  //  id, image
  // };
  // return this.Http.post(this.url + 'api/changecover', JSON.stringify(credentials), {headers: headers});
  // }  
  addclinic(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { item };
    return this.Http.post(this.url + 'api/addclinic', JSON.stringify(credentials), { headers: headers });
  }
  newpass(token, oPassword, nPassword) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, oPassword, nPassword };
    return this.Http.post(this.url + 'api/newpass', JSON.stringify(credentials), { headers: headers });
  }
  myinvoce(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { item };
    return this.Http.post(this.url + 'api/myinvoce', JSON.stringify(credentials), { headers: headers });
  }
  joinusall(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { item };
    return this.Http.post(this.url + 'api/joinusall', JSON.stringify(credentials), { headers: headers });
  }
  allinvoce(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { item };
    return this.Http.post(this.url + 'api/allinvoce', JSON.stringify(credentials), { headers: headers });
  }
  payment_gateway(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { item };
    return this.Http.post(this.url + 'api/payment_gateway', JSON.stringify(credentials), { headers: headers });
  }
  payment_gateway_offer(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { item };
    return this.Http.post(this.url + 'api/payment_gateway_offer', JSON.stringify(credentials), { headers: headers });
  }
  addoffers(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { item };
    return this.Http.post(this.url + 'api/addoffers', JSON.stringify(credentials), { headers: headers });
  }
  addpromotion(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { item };
    return this.Http.post(this.url + 'api/addpromotion', JSON.stringify(credentials), { headers: headers });
  }
  updateoffers(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { item };
    return this.Http.post(this.url + 'api/updateoffers', JSON.stringify(credentials), { headers: headers });
  }
  updatepromotion(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { item };
    return this.Http.post(this.url + 'api/updatepromotion', JSON.stringify(credentials), { headers: headers });
  }
  deleteoffers(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { item };
    return this.Http.post(this.url + 'api/deleteoffers', JSON.stringify(credentials), { headers: headers });
  }
  deletepromotion(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { item };
    return this.Http.post(this.url + 'api/deletepromotion', JSON.stringify(credentials), { headers: headers });
  }







  addcategory(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { item };
    return this.Http.post(this.url + 'api/addcategory', JSON.stringify(credentials), { headers: headers });
  }
  addservice(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { item };
    return this.Http.post(this.url + 'api/addservice', JSON.stringify(credentials), { headers: headers });
  }
  updatecategory(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { item };
    return this.Http.post(this.url + 'api/updatecategory', JSON.stringify(credentials), { headers: headers });
  }
  updateservice(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { item };
    return this.Http.post(this.url + 'api/updateservice', JSON.stringify(credentials), { headers: headers });
  }
  randomPassword(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { item };
    return this.Http.post(this.url + 'api/randomPassword', JSON.stringify(credentials), { headers: headers });
  }
  updateuser(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { item };
    return this.Http.post(this.url + 'api/updateuser', JSON.stringify(credentials), { headers: headers });
  }
  findallappointmentbyclinic_id(clinic_id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { clinic_id };
    return this.Http.post(this.url + 'api/findallappointmentbyclinic_id', JSON.stringify(credentials), { headers: headers });
  }
  findclinicById(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { item };
    return this.Http.post(this.url + 'api/findclinicById', JSON.stringify(credentials), { headers: headers });
  }
  finduseroffers(id_clinic) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { id_clinic };
    return this.Http.post(this.url + 'api/finduseroffers', JSON.stringify(credentials), { headers: headers });
  }
  deleteservice(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { item };
    return this.Http.post(this.url + 'api/deleteservice', JSON.stringify(credentials), { headers: headers });
  }
  deletecategory(token, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token , id  };
    return this.Http.post(this.url + 'api/deletecategories', JSON.stringify(credentials), { headers: headers });
  }
  deleteregions(token, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, id };
    return this.Http.post(this.url + 'api/deleteregions', JSON.stringify(credentials), { headers: headers });
  }
  deletearea(token, id) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { token, id };
    return this.Http.post(this.url + 'api/deletearea', JSON.stringify(credentials), { headers: headers });
  }
  addUser(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { item };
    return this.Http.post(this.url + 'api/addUser', JSON.stringify(credentials), { headers: headers });
  }
  deleteappointment(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { item };
    return this.Http.post(this.url + 'api/deleteappointment', JSON.stringify(credentials), { headers: headers });
  }
  noshowappointment(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { item };
    return this.Http.post(this.url + 'api/noshowappointment', JSON.stringify(credentials), { headers: headers });
  }
  confirmedappointment(item) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let credentials = { item };
    return this.Http.post(this.url + 'api/confirmedappointment', JSON.stringify(credentials), { headers: headers });
  }
}
